module.exports = __webpack_public_path__ + "static/media/coingossip-main.ad95aa4e.png";